var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLanceDb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.26 0 0 8.26 331.75 245.75)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1.66 1.66)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,94,255)",
      fillOpacity: 0.2,
      fillRule: "nonzero",
      opacity: 1
    },
    x: -22.3404,
    y: -22.3404,
    rx: 0,
    ry: 0,
    width: 44.6808,
    height: 44.6808
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1.66 -1.66)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,94,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -22.3404,
    y: -22.3404,
    rx: 0,
    ry: 0,
    width: 44.6808,
    height: 44.6808
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.91 8.91)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-15.09, -32.91)",
    d: "M 20.2232 27.777 C 19.8894 27.4433 19.348 27.4433 19.0142 27.777 L 9.95345 36.8382 C 9.61968 37.1719 9.61968 37.7134 9.95345 38.0472 C 10.1201 38.2139 10.3392 38.2974 10.558 38.2974 C 10.7767 38.2974 10.9954 38.2139 11.1625 38.0472 L 20.2232 28.9842 C 20.557 28.6504 20.557 28.1097 20.2232 27.777 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.92 2.88)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-15.08, -26.88)",
    d: "M 12.6742 30.4952 L 18.6945 24.475 C 19.0282 24.1412 19.0282 23.5997 18.6945 23.266 C 18.3607 22.9322 17.8211 22.9322 17.4874 23.266 L 11.4671 29.2862 C 11.1334 29.62 11.1334 30.1614 11.4671 30.4952 C 11.6338 30.6619 11.8522 30.7454 12.0709 30.7454 C 12.2896 30.7454 12.5075 30.6619 12.6742 30.4952 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -2.88 8.92)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-21.12, -32.92)",
    d: "M 23.5245 29.307 L 17.5042 35.3291 C 17.1705 35.6617 17.1705 36.2032 17.5042 36.5362 C 17.6709 36.7029 17.8893 36.7864 18.108 36.7864 C 18.3267 36.7864 18.5443 36.7029 18.7113 36.5362 L 24.7335 30.516 C 25.0673 30.1822 25.0673 29.6407 24.7335 29.307 C 24.3997 28.9732 23.8579 28.9732 23.5245 29.307 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 5.28 -4.72)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-29.28, -19.28)",
    d: "M 24.7824 10.3418 L 27.4694 20.3828 C 27.5149 20.5523 27.6041 20.7069 27.7282 20.831 C 27.8524 20.9552 28.007 21.0444 28.1765 21.0899 L 38.2175 23.7769 C 38.386 23.822 38.5635 23.8223 38.7322 23.7777 C 38.9009 23.733 39.055 23.645 39.1791 23.5223 C 39.3042 23.3982 39.3943 23.2432 39.4402 23.0731 C 39.4862 22.903 39.4864 22.7238 39.4407 22.5536 L 36.7467 12.5197 C 36.7012 12.3502 36.612 12.1956 36.4879 12.0714 C 36.3637 11.9473 36.2091 11.8581 36.0396 11.8126 L 26.0057 9.11854 C 25.8355 9.07294 25.6563 9.07311 25.4862 9.11906 C 25.316 9.165 25.1611 9.25508 25.037 9.38017 C 24.9143 9.50432 24.8263 9.6584 24.7816 9.82711 C 24.737 9.99581 24.7373 10.1733 24.7824 10.3418 V 10.3418 Z M 34.9365 13.6228 L 37.0578 21.401 L 29.2796 19.2797 L 27.1583 11.5015 L 34.9365 13.6228 Z M 35.8769 24.7032 L 26.4512 22.1081 L 23.8844 12.6541 C 23.8504 12.5266 23.7916 12.4071 23.7113 12.3025 C 23.631 12.1979 23.5307 12.1102 23.4164 12.0445 C 23.302 11.9787 23.1758 11.9363 23.0449 11.9196 C 22.9141 11.9028 22.7813 11.9121 22.654 11.947 C 22.3995 12.0171 22.183 12.1852 22.0519 12.4143 C 21.9207 12.6435 21.8855 12.9152 21.954 13.1703 L 24.641 23.2112 C 24.6864 23.3807 24.7757 23.5353 24.8998 23.6595 C 25.0239 23.7836 25.1786 23.8729 25.3481 23.9183 L 35.389 26.6053 C 35.644 26.6738 35.9158 26.6386 36.145 26.5074 C 36.3741 26.3763 36.5421 26.1598 36.6123 25.9053 C 36.6472 25.778 36.6565 25.6452 36.6397 25.5143 C 36.623 25.3835 36.5806 25.2573 36.5148 25.1429 C 36.4491 25.0286 36.3614 24.9283 36.2568 24.848 C 36.1522 24.7677 36.0327 24.7088 35.9052 24.6749 L 35.8769 24.7032 Z M 33.0485 27.5316 L 23.6228 24.9365 L 21.056 15.4825 C 21.022 15.355 20.9632 15.2356 20.8829 15.1309 C 20.8025 15.0263 20.7023 14.9386 20.588 14.8729 C 20.4736 14.8072 20.3474 14.7647 20.2165 14.748 C 20.0857 14.7313 19.9528 14.7406 19.8256 14.7754 C 19.5711 14.8456 19.3546 15.0136 19.2234 15.2428 C 19.0923 15.4719 19.0571 15.7437 19.1256 15.9987 L 21.8126 26.0396 C 21.858 26.2092 21.9473 26.3638 22.0714 26.4879 C 22.1955 26.612 22.3501 26.7013 22.5197 26.7467 L 32.5606 29.4337 C 32.8156 29.5022 33.0874 29.467 33.3165 29.3358 C 33.5457 29.2047 33.7137 28.9882 33.7839 28.7337 C 33.8187 28.6065 33.828 28.4736 33.8113 28.3428 C 33.7946 28.2119 33.7521 28.0857 33.6864 27.9713 C 33.6207 27.857 33.533 27.7568 33.4284 27.6764 C 33.3237 27.5961 33.2042 27.5373 33.0768 27.5033 L 33.0485 27.5316 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanceDb);
export default __webpack_public_path__ + "static/media/LanceDB.f6e24b937ec91901685b288a3a6f2bb9.svg";
export { ForwardRef as ReactComponent };